import { render, staticRenderFns } from "./custodian_monthly_reports.vue?vue&type=template&id=0964cebf&"
import script from "./custodian_monthly_reports.vue?vue&type=script&lang=js&"
export * from "./custodian_monthly_reports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports